import styled, { css } from 'styled-components';
import theme from '|/components/base/theme';
import CarvanaLogoHorizontal from '|/icons/carvana-logo-horizontal.svg';
import PurchaseHeaderLogo from '|/icons/purchase-header-logo.svg';

type LogoProps = {
  $isNativeWebview: boolean;
};

export const HeaderWrapper = styled.div`
  width: 100%;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  -webkit-font-smoothing: antialiased;

  a {
    text-decoration: none;
  }

  @media (min-width: ${theme.breakpoints.sm}) {
    padding-top: 0;
  }
`;

const StickyMobileHeader = css`
  position: sticky;
  position: 'sticky';
  top: 0;
  z-index: 10;
`;

export const PurchaseHeaderWrapper = styled.div`
  background-color: #fff;
  height: 60px;
  border-bottom: 1px solid #d9dde9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;

  @media (max-width: ${theme.breakpoints.sm}) {
    ${StickyMobileHeader}
  }
`;

export const StyledPurchaseHeaderLogo = styled(PurchaseHeaderLogo)<LogoProps>`
  cursor: pointer;

  &:focus {
    outline: none;
  }

  @media (min-width: ${theme.breakpoints.sm}) {
    display: none;
  }
  ${props =>
    props.$isNativeWebview &&
    css`
      visibility: hidden;
    `}
`;

export const StyledHorizontalCarvanaLogo = styled(CarvanaLogoHorizontal)`
  @media (max-width: ${theme.breakpoints.sm}) {
    display: none;
  }

  cursor: pointer;
  height: 36px;
  width: auto;

  &:focus {
    outline: none;
  }
`;

export const TimerCartWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  float: right;

  @media (max-width: ${theme.breakpoints.sm}) {
    flex-grow: 1;
    margin-left: 14px;
    margin-right: 8px;
    justify-content: space-between;
  }
`;

export const TimerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 61px;
  border: 1px solid #d9dde9;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 16px;
  white-space: nowrap;
  cursor: pointer;

  @media (max-width: ${theme.breakpoints.sm}) {
    border: none;
    border-radius: 0;
    padding: 0;
  }
`;

export const CartWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  border-radius: 61px;
  border: 1px solid #d9dde9;
  padding: 8px 12px;
  width: auto;
  font-size: 14px;
  line-height: 16px;
`;
